import React from 'react';
import '../styles/updates.css';

export class SiteUpdatesProps 
{
    headerClass ?: string|undefined = undefined;
    containerClass ?: string|undefined = undefined;
    contentsClass ?: string|undefined = undefined;
    headerContents : React.ReactElement[]|React.ReactElement = [];
    updates : SiteUpdateProps[] = [];
}

export function SiteUpdates(props: SiteUpdatesProps)
{
    const headerClass : string = props.headerClass !== undefined ? props.headerClass : 'site-update-box-header';
    const containerClass : string = props.containerClass !== undefined ? props.containerClass : 'site-update-box-container';
    const contentsClass : string = props.contentsClass !== undefined ? props.contentsClass : 'site-update-box-contents';

    return <div className={containerClass}>
        <div className={headerClass}>
            {props.headerContents}
        </div>
        <div className={contentsClass}>
            { props.updates.map((u, i) => {
                const update = u;
                update.id = 'site-update-' + i.toString();
                return SiteUpdate(update);
            })}
        </div>
    </div>
}

export class SiteUpdateProps 
{
    headerContents : React.ReactElement[]|React.ReactElement = [];
    bodyContents : React.ReactElement[]|React.ReactElement = [];
    mainClass ?: string|undefined = undefined;
    headerClass ?: string|undefined = undefined;
    bodyClass ?: string|undefined = undefined;
    id ?: string = undefined;
}

export function SiteUpdate(props: SiteUpdateProps)
{
    const mainClass : string = props.mainClass !== undefined ? props.mainClass : 'site-update-main';
    const headerClass : string = props.headerClass !== undefined ? props.headerClass : 'site-update-header';
    const bodyClass : string = props.bodyClass !== undefined ? props.bodyClass : 'site-update-body';

    let id = props.id !== undefined ? props.id : '';

    return <div key={id} className={mainClass}>
        <div className={headerClass}>
            {props.headerContents}            
        </div>
        <div className={bodyClass}>
            {props.bodyContents}
        </div>
    </ div>
}